import { formatDate } from 'date-fns';

export function formatDateDateOnly(date: string | Date | undefined): string {
  if (!date) {
    return '';
  }
  return formatDate(date, 'dd-MMM-yyyy');
}

export function formatDateTime(date: string | Date | undefined): string {
  if (!date) {
    return '';
  }
  return new Date(`${date}z`).toLocaleString();
}

export function parseDateOnly(date: string): Date {
  const split = date.split('-');
  return new Date(parseInt(split[0]), parseInt(split[1]) - 1, parseInt(split[2]));
}

export function formatDateTimeDay(date: string | Date | undefined): string {
  if (!date) {
    return '';
  }
  return formatDate(date, 'EEEE MMM d yyyy h:mm a');
}

export function formatDateTimeHomePage(date: string | Date | undefined): string {
  if (!date) {
    return '';
  }

  return formatDate(date, 'EEE dd-MMM yyyy h:mm a');
}

export function formatDateTimeReportHeader(dateTimeStr: string | undefined, timeZone: string): string {
  if (!dateTimeStr || !timeZone) {
    return '';
  }

  return `${formatDateTimeDay(dateTimeStr)} ${timeZone}`;
}

export function formatTimeSpan(timeSpanString: string | undefined): string {
  if (!timeSpanString) return '0m';

  const timeSpan = parseTimeSpan(timeSpanString);
  if (!timeSpan) return '0m';

  const hours = Math.floor(timeSpan.totalMinutes / 60);
  const minutes = Math.floor(timeSpan.totalMinutes % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}

function parseTimeSpan(timeSpanString: string | undefined) {
  if (!timeSpanString) return null;

  // Parse C# TimeSpan format (e.g., "01:30:45" or "1.02:30:45.123")
  const match = timeSpanString.match(/(?:(\d+)\.)?(\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))?/);
  if (!match) return null;

  const [, days = '0', hours, minutes, seconds] = match;
  const totalMinutes =
    parseInt(days) * 24 * 60 + parseInt(hours) * 60 + parseInt(minutes) + (parseInt(seconds) > 30 ? 1 : 0);

  return { totalMinutes };
}
